type SchedulePeriod = {
  start?: unknown;
  end?: unknown;
};

type ScheduleDay = {
  closed?: boolean;
  periods?: SchedulePeriod[];
};

type RestaurantConfiguration = {
  rua?: unknown;
  cidade?: unknown;
  estado?: unknown;
  horarios_semana?: ScheduleDay[];
};

const hasText = (value: unknown): boolean => String(value ?? '').trim().length > 0;

export const shouldShowIfoodImportInvite = (
  configuration: RestaurantConfiguration,
): boolean => {
  const hasAddress = hasText(configuration.rua)
    && hasText(configuration.cidade)
    && hasText(configuration.estado);
  const hasHours = Array.isArray(configuration.horarios_semana)
    && configuration.horarios_semana.some((day) => (
      day?.closed !== true
      && Array.isArray(day?.periods)
      && day.periods.some((period) => hasText(period?.start) && hasText(period?.end))
    ));

  return !(hasAddress && hasHours);
};
